import { DayContent, type DayContentProps } from "react-day-picker";

import { useLanguage } from "@/lib/i18n/LanguageContext";
import { RANGE_END, RANGE_START } from "./issueDateRangeModifiers";

/**
 * A day cell that appends an endpoint's role to its accessible name, so the
 * counterpart date is announced and not only coloured.
 *
 * It lives in its own module, and reads the labels itself, so its component
 * identity is a constant: a `DayContent` built inside the hook's `useMemo` is a
 * new type whenever a date or the language changes, which unmounts and remounts
 * every day cell of an open calendar and drops keyboard focus mid-use.
 */
export function IssueRangeDayContent(props: DayContentProps) {
  const { t } = useLanguage();
  const roles = [
    props.activeModifiers[RANGE_START] ? t.pm.issues.detail.startDate : null,
    props.activeModifiers[RANGE_END] ? t.pm.issues.detail.dueDate : null,
  ].filter(Boolean);
  return (
    <>
      <DayContent {...props} />
      {roles.length > 0 && <span className="sr-only">, {roles.join(", ")}</span>}
    </>
  );
}
